module.exports = __webpack_public_path__ + "img/cosleep_guidance_img_subscribe-wechat6_cn@3x.fb29f786.png";